import { render, staticRenderFns } from "./host-layout.vue?vue&type=template&id=0c4d1685&scoped=true&"
import script from "./host-layout.vue?vue&type=script&lang=js&"
export * from "./host-layout.vue?vue&type=script&lang=js&"
import style0 from "./host-layout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./host-layout.vue?vue&type=style&index=1&id=0c4d1685&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d1685",
  null
  
)

export default component.exports